"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromEnvOrThrow = getFromEnvOrThrow;
exports.choose = choose;
exports.shuffle = shuffle;
exports.sleep = sleep;
const log = require("loglevel");
function getFromEnvOrThrow(env) {
    const result = process.env[env];
    if (result === null || result === undefined || result.trim() === '') {
        throw new Error(`${env} unset in environment!`);
    }
    log.debug(`Using ${env} = ${result}`);
    return result;
}
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
function choose(choices) {
    const index = Math.floor(Math.random() * choices.length);
    return choices[index];
}
/** Fisher-Yates shuffle — returns a new shuffled copy of the array */
function shuffle(array) {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}
async function sleep(millis) {
    await new Promise(resolve => setTimeout(resolve, millis));
}
